import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminLogin } from '../features/admin/views/AdminLogin';
import { AdminPrivateRoute } from './guards/AdminPrivateRoute';
import { AdminRoute } from './guards/AdminRoute';
import { AdminLayout } from '../features/admin/layout/AdminLayout';

export const AdminRouter: React.FC = () => {
  return (
    <Routes>
      {/* Rutas Públicas de Login */}
      <Route path="/login" element={<AdminLogin />} />

      {/* Rutas del Admin (Protegidas) */}
      <Route element={<AdminPrivateRoute />}>
        <Route element={<AdminLayout />}>
          <Route path="/admin/*" element={<AdminRoute />} />
        </Route>
      </Route>

      {/* Redirección por defecto */}
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
};
export default AdminRouter;
